import React from 'react'
import ArrowForwardIcon from '@mui/icons-material/ArrowForward'
import url from 'libraries/front-end-core/core/url'
import { QA_CONTENT } from 'constants/controllers'
import { parseHtmlContent } from 'helpers/parseHtmlContent'
import Xml from 'components/shared/Xml'
import cx from 'classnames'
import ResultBreadcrumbs from './ResultBreadcrumbs'

export const RelatedQaItem = ({ flavour, q, verifiedAnswer = false }) => {
  const {
    questionContent, answerContent, questionNumber, path,
    areaOfLaw: aol,
    bookmarkId: focusedId
  } = q
  const [section] = path

  if (!section) {
    return null
  }
  const sectionId = section.id
  const questionUrl = url(QA_CONTENT, {
    aol,
    flavour,
    sectionId,
    focusedId
  })

  return (
    <div className='w-100'>
      {verifiedAnswer && <div className='mb3 f4 fw5'>Good news, we think we found an exact answer:</div>}
      <div
        className={cx(
          'bg-white pv6 ph4 ph5-ns bt-thick b--dark-cerulean w-100 o-hidden wb-word shadow-1',
          {
            mt5: !verifiedAnswer
          }
        )}
      >
        <ResultBreadcrumbs {...{ aol, sectionId, path, flavour }} />
        <a
          href={questionUrl}
          className='f4 b black pb0 db no-underline hover-underline pointer lh-title w-100 wb-word'
          data-event-category='Q&A'
          data-event-action='Question Click'
          data-event-label={`Question ${questionNumber}`}
        >
          {parseHtmlContent(`Q${questionNumber}: ${questionContent}`)}
        </a>
        <div
          className={cx(
            'grey ph2 o-hidden no-pointer-events wb-word ws-normal w-100 f5 min-h4 relative content-view',
            {
              'h8 mb3': verifiedAnswer,
              'h4 mb5': !verifiedAnswer
            }
          )}
        >
          <Xml render={answerContent} sectionId={sectionId} />
          <div
            className={cx(
              'absolute bottom0 tile-frosted-bottom w-100',
              {
                h3: verifiedAnswer,
                h2: !verifiedAnswer
              }
            )}
          />
        </div>
        <a
          className='flex items-center f5 dark-cerulean pl2 pointer no-underline hover-underline mt3 w-100 content-text'
          href={questionUrl}
        >
          Read more
          <ArrowForwardIcon className='ml2 dark-cerulean f4' />
        </a>
      </div>
    </div>
  )
}
